var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#FFE1E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_617_5196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.75 23.5H41V20.5775C40.9589 19.4572 40.4754 18.3988 39.6553 17.6345C38.8351 16.8701 37.7454 16.4622 36.625 16.5H31.375C30.2546 16.4622 29.1649 16.8701 28.3448 17.6345C27.5246 18.3988 27.0411 19.4572 27 20.5775V23.5H18.25C17.7859 23.5 17.3408 23.6843 17.0126 24.0125C16.6844 24.3407 16.5 24.7858 16.5 25.25C16.5 25.7141 16.6844 26.1592 17.0126 26.4874C17.3408 26.8156 17.7859 27 18.25 27H20V46.25C20 47.6424 20.5531 48.9777 21.5377 49.9623C22.5223 50.9468 23.8576 51.5 25.25 51.5H42.75C44.1424 51.5 45.4777 50.9468 46.4623 49.9623C47.4469 48.9777 48 47.6424 48 46.25V27H49.75C50.2141 27 50.6592 26.8156 50.9874 26.4874C51.3156 26.1592 51.5 25.7141 51.5 25.25C51.5 24.7858 51.3156 24.3407 50.9874 24.0125C50.6592 23.6843 50.2141 23.5 49.75 23.5ZM30.5 20.5775C30.5 20.2975 30.8675 20 31.375 20H36.625C37.1325 20 37.5 20.2975 37.5 20.5775V23.5H30.5V20.5775ZM44.5 46.25C44.5 46.7141 44.3156 47.1592 43.9874 47.4874C43.6593 47.8156 43.2141 48 42.75 48H25.25C24.7859 48 24.3408 47.8156 24.0126 47.4874C23.6844 47.1592 23.5 46.7141 23.5 46.25V27H44.5V46.25Z",
    fill: "#DA4848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.75 42.75C29.2141 42.75 29.6592 42.5656 29.9874 42.2374C30.3156 41.9092 30.5 41.4641 30.5 41V34C30.5 33.5359 30.3156 33.0908 29.9874 32.7626C29.6592 32.4344 29.2141 32.25 28.75 32.25C28.2859 32.25 27.8408 32.4344 27.5126 32.7626C27.1844 33.0908 27 33.5359 27 34V41C27 41.4641 27.1844 41.9092 27.5126 42.2374C27.8408 42.5656 28.2859 42.75 28.75 42.75Z",
    fill: "#DA4848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.25 42.75C39.7141 42.75 40.1592 42.5656 40.4874 42.2374C40.8156 41.9092 41 41.4641 41 41V34C41 33.5359 40.8156 33.0908 40.4874 32.7626C40.1592 32.4344 39.7141 32.25 39.25 32.25C38.7859 32.25 38.3408 32.4344 38.0126 32.7626C37.6844 33.0908 37.5 33.5359 37.5 34V41C37.5 41.4641 37.6844 41.9092 38.0126 42.2374C38.3408 42.5656 38.7859 42.75 39.25 42.75Z",
    fill: "#DA4848"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_617_5196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.cad60fe52af8efcd224a9b42b664bcd6.svg";
export { ForwardRef as ReactComponent };